<template>
  <vs-popup :title="$t('modality.titles')" :active.sync="visible" id="popup-modality" @close="closePopup" ref="vspopup-modality">
    <Grid
        ref="grid-modality-popup"
        :multipleSelect="true"
        :service="modalityService"
        @changedSelection="changedSelection"
        route_name="modalities"
        hide_actions="true"
        order_column="name"
        :request-params="filtersGrid">
      </Grid>
      <!--:request-params="applyFiltersGrid"-->
    <div class="flex flex-row justify-end gap-4">
        <b-button
          @click="addModalities"
          variant="primary"
          icon="add">
          {{ $t('adicionar') }}
        </b-button>
    </div>
  </vs-popup>
</template>

<script>
import ModalityService from '@/services/api/ModalityService'

import {
BButton
} from 'bootstrap-vue'

export default {
components: {
  BButton
},
props: {
  visible :{
    type: Boolean,
    default: false
  },
  filters :{
    type: String,
    default: null
  }
},
data: () => ({
  modalityService: null,
  selectedModalities: []
}),
computed: {
  filtersGrid(){
    return this.filters
  }
},
methods: {
  changedSelection(items) {
    this.selectedModalities = items
  },
  itemSelected(modality) {
    const modalityIndex = this.selectedModalities.findIndex((_modality) => _modality === modality.id)

    if (modalityIndex !== -1) {
      const newArray = this._.cloneDeep(this.selectedModalities)
      newArray.splice(modalityIndex, 1)
      this.selectedModalities = newArray
    } else {
      this.selectedModalities.push(modality.id)
    }
  },
  addModalities() {
    this.$emit('selected', [...this.selectedModalities])
    this.$emit('close', false)
  },
  closePopup(value){
    this.$emit('close', value)
  },
  applyFiltersGrid(){
    if(this.filters){
      this.getGrid().fillCustomFilters(this.filters)
      this.getGrid().fetchGridData(false)
    }
  },
  getGrid(){
    const gripP = this.$refs['grid-modality-popup']
    return gripP
  }
},
beforeMount() {
  this.modalityService = ModalityService.build(this.$vs)
},
mounted() {

},
watch: {
  visible(val){
    if(val){
      //this.applyFiltersGrid()
    }
  }
},
}
</script>


<style lang="scss" scoped>
::v-deep .vs-popup {
  width: 800px !important;
}
</style>
